import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { SystemNotification } from '../models/Notification';
import { CustomHttpError } from '../utils/CustomHttpError';
import { EnvironmentService } from './environment.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class SystemNotificationsService {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly env = inject(EnvironmentService);
  private readonly toastService = inject(ToastService);

  public get(): Observable<Array<SystemNotification>> {
    return this.httpClient.get<Array<SystemNotification>>(`${this.env.getBaseRestUrl()}/notification`).pipe(
      catchError((e: CustomHttpError) => {
        console.error('Error requesting notifications', e);
        this.toastService.genericError(e.traceId);
        return of([]);
      })
    );
  }
}
